export enum PACCProgress {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CONNECT_OVER = 'CONNECT_OVER',
}

export type PACCProgressType = keyof typeof PACCProgress;

export enum PSTProgress {
  BEFORE_PROGRESS = 'BEFORE_PROGRESS',
  IN_PROGRESS = 'IN_PROGRESS',
  END = 'END',
}

export const ProgressStatusList = ['NOT_STARTED', 'IN_PROGRESS', 'BEFORE_PROGRESS', 'IN_PROGRESS'];
